import { useParams, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import API from "../services/api";
import BrandFilter from "../component/Category/BrandFilter/BrandFilter";
import ProductCard from "../component/Product/ProductCard";
import "./CategoryProducts.css";

function CategoryProducts({ setCartCount, isLoggedIn }) {

    const { id } = useParams();
    const navigate = useNavigate();

    const [products, setProducts] = useState([]);
    const [brands, setBrands] = useState([]);
    const [selectedBrand, setSelectedBrand] = useState(null);
    const [wishlist, setWishlist] = useState({});

    useEffect(() => {

        const fetchProducts = async () => {
            try {

                const response = await API.get(
                    `/api/categories/${id}/products`
                );

                setProducts(response.data);

            } catch (error) {
                console.log("Category products error:", error);
            }
        };

        const fetchBrands = async () => {
            try {

                const response = await API.get(
                    `/api/brand/${id}/brands`
                );

                setBrands(response.data);

            } catch (error) {
                console.log("Category brands error:", error);
            }
        };

        fetchProducts();
        fetchBrands();

    }, [id]);


    // =====================================
    // ONLY FETCH WISHLIST FOR LOGGED USER
    // =====================================

    useEffect(() => {

        if (isLoggedIn) {
            fetchWishList();
        } else {
            setWishlist({});
        }

    }, [isLoggedIn]);


    const fetchWishList = async () => {

        try {

            const response = await API.get("/api/wishlist");

            const data = {};

            response.data.forEach(item => {
                data[item.product.id] = true;
            });

            setWishlist(data);

        } catch (error) {

            console.log("Wishlist error:", error);

        }

    };


    // =====================================
    // CART
    // =====================================

    const handleToCart = async (productId) => {

        if (!isLoggedIn) {
            navigate("/login");
            return;
        }

        try {

            await API.post(
                `/api/cart?productId=${productId}&quantity=1`
            );

            const response = await API.get("/api/cart");

            setCartCount(response.data.length);

            alert("Added to cart");

        } catch (error) {

            console.log(error);
            alert("Failed to add to cart");

        }

    };


    // =====================================
    // WISHLIST
    // =====================================

    const handleWishList = async (
        productId,
        isAdded,
        setIsAdded
    ) => {

        if (!isLoggedIn) {
            navigate("/login");
            return;
        }

        try {

            if (isAdded) {

                await API.post(
                    `/api/wishlist/remove/${productId}`
                );

                setIsAdded(false);

            } else {

                await API.post(
                    `/api/wishlist/add/${productId}`
                );

                setIsAdded(true);

            }

        } catch (error) {

            console.log(error);
            alert("WishList error");

        }

    };


    const filteredProducts = selectedBrand
        ? products.filter(
            product =>
                product.brands?.id === selectedBrand
        )
        : products;


    return (
        <div className="category-page">

            <div className="category-container">

                <BrandFilter
                    brands={brands}
                    selectedBrand={selectedBrand}
                    setSelectedBrand={setSelectedBrand}
                />

                <section className="products-section">

                    <div className="section-heading">

                        <h2>Products</h2>

                        <p>
                            {filteredProducts.length} products found
                        </p>

                    </div>

                    <div className="products-grid">

                        {filteredProducts.map(product => (

                            <ProductCard
                                key={product.id}
                                product={product}
                                wishlist={wishlist}
                                handleWishList={handleWishList}
                                handleToCart={handleToCart}
                                setWishlist={setWishlist}
                            />

                        ))}

                    </div>

                </section>

            </div>

        </div>
    );
}

export default CategoryProducts;